import { TableCell, TableRow, mergeClasses } from '@fluentui/react-components';
import { useSharedStyles } from '../shared-styles.js';
import type { FieldTableProps } from '../types.js';
import type { FieldValueRecord } from '../types.js';
import { useStyles } from './styles.js';

type FieldTableHeaderProps<TValue extends Array<FieldValueRecord>> = {
    tableCells: FieldTableProps<TValue>['tableCells'];
    cellsToRight: Record<keyof TValue[number], boolean>;
};

export function FieldTableHeader<TValue extends Array<FieldValueRecord>>({
    tableCells,
    cellsToRight,
}: FieldTableHeaderProps<TValue>) {
    const styles = useStyles();
    const sharedStyles = useSharedStyles();

    return (
        <TableRow className={sharedStyles.tableDisplayContents}>
            {tableCells.map((cell, cellIndex) => (
                <TableCell
                    key={cellIndex}
                    className={mergeClasses(
                        sharedStyles.tableCell,
                        styles.tableCellHeader,
                        cellsToRight[cell.key] && sharedStyles.tableCellAlignRight
                    )}
                >
                    {cell.label}
                </TableCell>
            ))}
        </TableRow>
    );
}
